import { render, staticRenderFns } from "./ClinicianDischargeFromProgram.vue?vue&type=template&id=4dbaea79"
import script from "./ClinicianDischargeFromProgram.vue?vue&type=script&lang=js"
export * from "./ClinicianDischargeFromProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports